module.exports = __webpack_public_path__ + "img/lunBo.07d725e2.png";